// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2wm1q","errorLogs":"EditorFooter_errorLogs__eNDY6"};